import React from "react";
import { Box, Typography } from "@mui/material";
import { rf } from "./theme";

// Reinforce's own mark, deliberately unrelated to any other brand of ours.
//
// Two chevrons over a base line: the same move made again, each time from a
// firmer footing. Outlined in the same black as every card on the page, so the
// logo belongs to the system rather than sitting on top of it.
const Mark = ({ size = 34, mono }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" role="img" aria-label="Reinforce" focusable="false">
    <rect
      x="1.6"
      y="1.6"
      width="36.8"
      height="36.8"
      rx="11"
      fill={mono ? "transparent" : rf.coral}
      stroke={mono ? "currentColor" : rf.ink}
      strokeWidth="3.2"
    />
    <g fill="none" stroke={mono ? "currentColor" : rf.ink} strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11.8 19.4 L20 11.8 L28.2 19.4" />
      <path d="M11.8 26.6 L20 19 L28.2 26.6" opacity={mono ? 0.55 : 0.45} />
    </g>
    <rect x="12" y="30" width="16" height="3.4" rx="1.7" fill={mono ? "currentColor" : rf.ink} />
  </svg>
);

const SIZES = {
  small: { mark: 28, text: 17 },
  medium: { mark: 36, text: 21 },
  large: { mark: 48, text: 28 },
};

export const BrandLogo = ({ size = "medium", showText = true, mono = false, onClick, sx }) => {
  const dims = SIZES[size] || SIZES.medium;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.1,
        cursor: onClick ? "pointer" : "default",
        color: mono ? "inherit" : undefined,
        ...sx,
      }}
    >
      <Mark size={dims.mark} mono={mono} />
      {showText && (
        <Typography
          component="span"
          sx={{
            fontFamily: rf.display,
            fontWeight: 800,
            fontSize: dims.text,
            letterSpacing: "-0.03em",
            color: mono ? "inherit" : rf.ink,
            lineHeight: 1,
          }}
        >
          Reinforce
        </Typography>
      )}
    </Box>
  );
};

export default BrandLogo;
